module.exports = __webpack_public_path__ + "assets/img/login-bj.d7ab35c4.png";